import * as React from 'react';
import AidForm from './Aid';
import MotorFunctionForm from './MotorFunction';
import { formDataByType } from 'Utility/documentHandling';

const Form = ({ formData, document }: IOwnProps): React.JSX.Element | null => {
  switch (document?._type) {
    case 'motorfunction':
      return <MotorFunctionForm formData={formDataByType(formData, document)} />;
    case 'mobilityAid':
      return <AidForm formData={formDataByType(formData, document)} />;
    default:
      return null;
  }
};

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'mobilityAid' | 'motorfunction'>>;
  document?: IDocumentWithTypeV2<'motorfunction' | 'mobilityAid'>;
}

export default Form;
